import PropTypes from 'prop-types';

/**
 * employer resources tag data
 */
export const rawSingleMarketingTagShape = PropTypes.shape({
    /**
     * id of the tag
     */
    id: PropTypes.number,
    /**
     * name of the tag
     */
    name: PropTypes.string,
    /**
     * whether it is active tag
     */
    active: PropTypes.number,
    /**
     * created at
     */
    created_at: PropTypes.string,
    /**
     * updated at
     */
    updated_at: PropTypes.string,
});

/**
 * list of employers resources tag
 */
export const rawMarketingTagsShape = PropTypes.arrayOf(
    rawSingleMarketingTagShape
);

/**
 * employer resources id for single Resource
 */
export const singleResourceIdShape = PropTypes.number;

/**
 * meta data for image for single Resource
 */
export const singleResourceImageShape = PropTypes.shape({
    src: PropTypes.string,
    alt: PropTypes.string,
});

/**
 * url of single resource page for single Resource
 */
export const singleResourceContentUrlShape = PropTypes.string;

/**
 * title of resource for single Resource
 */
export const singleResourceTitleShape = PropTypes.string;

/**
 * meta data for resource's tag for single Resource
 */
export const singleResourceMarketingTagShape = PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    url: PropTypes.string,
});

/**
 * employer resources data
 */
export const singleResourceShape = PropTypes.shape({
    id: singleResourceIdShape,
    image: singleResourceImageShape,
    contentUrl: singleResourceContentUrlShape,
    title: singleResourceTitleShape,
    marketingTag: singleResourceMarketingTagShape,
});

/**
 * list of employers resources
 */
export const resourcesShape = PropTypes.arrayOf(singleResourceShape);

export const databaseTypeShape = PropTypes.oneOf([
    'VCF_ADMIN',
    'VCF_EMPLOYER',
    'ALL_JOB_SEEKERS_ADMIN',
    'ALL_JOB_SEEKERS_EMPLOYER',
    'QUICK_APPLIES_ADMIN',
    'QUICK_APPLIES_EMPLOYER',
    'null_ADMIN', // on initital load, no db is selected
]).isRequired;
